class WizardSecureAndDownloadApp {
    constructor(wizardStep) {
        let searchParams = new URLSearchParams(window.location.search);
        this.wizardStep = wizardStep;
        this.organizationID = searchParams.get('organizationID');
        this.initWizard();
        new GaClipboard().initByID('wizard_ip_address');
        new GaClipboard().initByID('wizard_team_name');
    }
    initWizard(){
        const thisClass     = this;
        let wizardEl        = document.querySelector('#secure_and_download_app');
        let submitButtonEl  = wizardEl.querySelector('[data-kt-stepper-action="submit"]');

        // Init
        const options = {startIndex: this.wizardStep};
        const wizard = new KTStepper(wizardEl, options);

        // Handle navigation click
        wizard.on("kt.stepper.click", function (stepper) {
            stepper.goTo(stepper.getClickedStepIndex()); // go to clicked step
            thisClass.updateWizardStep(stepper.getCurrentStepIndex(),false);
        });

        // Next event
        wizard.on('kt.stepper.next', function (stepper) {
            stepper.goNext();
            thisClass.updateWizardStep(stepper.getCurrentStepIndex(),false);
            KTUtil.scrollTop();
        });

        // Prev event
        wizard.on('kt.stepper.previous', function (stepper) {
            stepper.goPrevious();
            thisClass.updateWizardStep(stepper.getCurrentStepIndex(),false);
            KTUtil.scrollTop();
        });

        submitButtonEl.addEventListener('click', function (e) {
            thisClass.updateWizardStep(0,true);
        });
    }
    updateWizardStep(wizardStep, reload){
        const thisClass = this;
        $.ajax({
            url: '/?do=updateWizardStep',
            type: 'POST',
            dataType: '',
            data: { organizationID: thisClass.organizationID, wizardStep: wizardStep },
        }).done(function(data) {
            if(reload){
                location.reload();
            }
        });
    }
}
window.WizardSecureAndDownloadApp = WizardSecureAndDownloadApp;